// frontend/src/hooks/useTheme.js

import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useTheme = () => {
  const theme = useSelector((state) => state.auth.theme);

  useEffect(() => {
    const root = window.document.documentElement;
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

    const effectiveTheme = theme === 'system' ? systemTheme : theme;

    // Custom CSS variable scope
    root.setAttribute('data-theme', effectiveTheme);

    // Bootstrap 5.3 native dark mode scope (fixes modals, forms, tables having black text)
    root.setAttribute('data-bs-theme', effectiveTheme);
  }, [theme]);
};